import { useQuery } from '@tanstack/react-query';
import type { ApiResponse } from '../../@types/ApiResponse';
import type { RequestStateQuery } from '../../@types/RequestStateQuery';
import type { User } from '../../@types/User';
import { getJSON } from '../../fetch';
import useAuth from '../../hooks/useAuth';
import useBranch from '../branch/useBranch';

export const SIGNED_IN_BRANCH_USER_QUERY = '/api/organisation/branches/:branchId/users/:email';

const useSignedInBranchUser = (): [User | undefined, RequestStateQuery] => {
  const [branch] = useBranch();
  const { getToken, decodedToken } = useAuth();

  const { data, isPending, isSuccess, isError } = useQuery<ApiResponse<User>>({
    queryKey: [SIGNED_IN_BRANCH_USER_QUERY, branch?.id],
    queryFn: async () =>
      await getJSON<ApiResponse<User>>(
        `/api/organisation/branches/${branch?.id}/users/${decodedToken?.email!}`,
        getToken(),
      ),
    enabled: !!branch?.id && !!decodedToken,
  });
  return [data?.response, { isLoading: isPending, isSuccess, isError }];
};

export default useSignedInBranchUser;
